import React, { Component } from "react";
import "./RightColumn.css";

import { Grid, Segment } from 'semantic-ui-react'

import { injectIntl, defineMessages } from "react-intl";
import StoriesContainer from "../../components/Stories/StoriesContainer/StoriesContainer";

const messages = defineMessages({
    found: {
        id: 'app.menu.found',
        defaultMessage: 'I was found'
    },
})


class RightColumn extends Component {
    shouldComponentUpdate(nextProps, nextState) {
        return false
    }

    render() {
        const { intl: { formatMessage } } = this.props;
        return (
            <StoriesContainer />
        );
    }
}

export default injectIntl(RightColumn);
